import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";

import PropTypes from "prop-types";
import ObjectUtils from "../../../utils/ObjectUtils";
import Question from "./Question";
import questionTypes from "./toolbox/questionTypes";

/**
 * Page is basically a tab in the survey editor.
 * Pages can be added, renamed and removed.
 * Each page contains a set of questions.
 * Page is a drop zone for predefined questions.
 */
class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionExpanded: -1,
      lastQuestionNew: false
    };
  }

  handleDragOver(event) {
    event.preventDefault();
  }

  handleDrop(event) {
    event.stopPropagation();
    event.preventDefault();

    let dragData;
    try {
      dragData = JSON.parse(event.dataTransfer.getData("text"));
    } catch (e) {
      return;
    }

    const { page, addQuestion } = this.props;
    const dragType = dragData.type;

    if (dragType === "question") {
      addQuestion(page.name, dragData.questionType);
      this.setState({ lastQuestionNew: true });
    }
  }

  handleQuestionExpand(questionId) {
    this.setState({ questionExpanded: questionId });
  }

  render() {
    const { page, selectedPage, questionSync, showModalForSavingQuestionToLibrary } = this.props;

    if (questionSync && this.state.lastQuestionNew) {
      showModalForSavingQuestionToLibrary(page.questions[page.questions.length - 1]);
      this.setState({ lastQuestionNew: false });
    }

    return selectedPage !== page.name ? (
      <></>
    ) : (
      <div className="dropzone" onDragOver={this.handleDragOver.bind(this)} onDrop={this.handleDrop.bind(this)}>
        <Accordion>
          {page.questions.map(function (question, i) {
            let questionTypeObj = ObjectUtils.findByObjectProp(questionTypes, "type", question.type);

            return (
              <Question
                {...this.props}
                key={i}
                component={questionTypeObj.component}
                question={question}
                pageName={page.name}
                questionNumber={1 + i}
                questions={page.questions}
                questionExpanded={this.state.questionExpanded}
                onQuestionExpand={this.handleQuestionExpand.bind(this)}
                questionSync={questionSync}
              />
            );
          }, this)}
        </Accordion>
      </div>
    );
  }
}

Page.propTypes = {
  page: PropTypes.object,
  selectedPage: PropTypes.string,
  addQuestion: PropTypes.func
};

export default Page;
